import React from 'react';
import { GridView, ListView } from '@one-thd/sui-icons';
import { IconButton, Typography } from '@one-thd/sui-atomic-components';
export const CardViewToggle = ({ isListView, onChangeToggle, }) => {
    return (React.createElement("div", { className: "sui-flex sui-gap-2 sui-justify-end sui-align-center" },
        React.createElement("div", { className: "sui-flex sui-flex-col" },
            React.createElement(IconButton, { icon: GridView, "aria-label": "Grid view", "data-testid": "grid-view-button", iconSize: "regular", color: !isListView ? 'brand' : 'primary', onClick: () => {
                    if (isListView) {
                        onChangeToggle();
                    }
                } }),
            React.createElement(Typography, { variant: "body-xs", align: "center" }, "Grid")),
        React.createElement("div", { className: "sui-flex sui-flex-col" },
            React.createElement(IconButton, { icon: ListView, "aria-label": "List view", "data-testid": "list-view-button", iconSize: "regular", color: isListView ? 'brand' : 'primary', onClick: () => {
                    if (!isListView) {
                        onChangeToggle();
                    }
                } }),
            React.createElement(Typography, { variant: "body-xs", align: "center" }, "List"))));
};
